export default __webpack_public_path__ + "static/media/side-image.d264de44.svg";